import { post, get } from './api';

export function fetchCosts() {
    return get('finance/paymantHitory');
}

export function fetchPaymentHistory() {
    return get('finance/fundHistory');
}

export function fetchBalance() {
    return get('finance/balance').then((res) => ({
        ...res,
        data: +res.data,
    }));
}

export function requestFund(values) {
    return post('finance/requestFund', values)
        .then((res) => {
            return Promise.resolve({
                ...res,
                data: {
                    id: res.data.id,
                    datetime: res.data.datetime,
                    link: res.data.link,
                    expires: res.data.expires,
                    paymentType: res.data.paymentType,
                    summa: res.data.summa,
                    status: res.data.status,
                    statusName: res.data.statusName,
                    isPrintable: res.data.isPrintable
                },
            });
        });
}

export function requestBalanceFund(values) {
    return post('finance/requestBalanceFund', values)
        .then((res) => {
            return Promise.resolve({
                ...res,
                data: {
                    id: res.data.id,
                    datetime: res.data.datetime,
                    link: res.data.link,
                    expires: res.data.expires,
                    paymentType: res.data.paymentType,
                    summa: res.data.summa,
                    status: res.data.status,
                    statusName: res.data.statusName,
                    isPrintable: res.data.isPrintable
                },
            });
        });
}

export function buy(id) {
    return post('finance/buy', {
        tariffVersionId: id
    }, 'json');
}



// WEBPACK FOOTER //
// ./src/services/api/finance.js